import { SimpleTreeView, useTreeViewApiRef } from "@mui/x-tree-view";
import CustomTreeItem from "./customTreeItem";
import { Button, Divider, Typography, useTheme } from "@mui/material";
import { JSX, useEffect, useState } from "react";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface CustomTreeViewProps {
  defaultExpandedItems?: string[];
  defaultSelectedItems?: string[];
  paginas: Dash[];
  title?: string;
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  closeOnClickItem?: boolean;
  titlePage?: string;
  setTitlePage?: React.Dispatch<React.SetStateAction<string>>;
  setLink?: React.Dispatch<React.SetStateAction<string>>;
  ocultar?: boolean;
  pageConfig?: boolean;
}

function CustomTreeView(props: CustomTreeViewProps): JSX.Element {
  const {
    // defaultExpandedItems = [],
    defaultSelectedItems = [],
    paginas = [],
    title = "",
    open = false,
    setOpen = () => {},
    closeOnClickItem = false,
    titlePage = "",
    setTitlePage = () => {},
    setLink = () => {},
    ocultar = false,
    pageConfig,
  } = props;
  const [selectedItems, setSelectedItems] = useState<string[]>();
  const [expandedItems, setExpandedItems] = useState<string[]>();
  const theme = useTheme();
  const apiRef = useTreeViewApiRef();
  const navigate = useNavigate();

  function findFirstFilho(paginas: Dash[]): Dash | undefined {
    for (const pagina of paginas) {
      if (pagina.type === "FILHO") return pagina;
      if (pagina.type === "PAI" && pagina.subPages?.length) {
        const found = findFirstFilho(pagina.subPages);
        if (found) return found;
      }
    }
    return undefined;
  }

  useEffect(() => {
    const pageName = window.location.pathname;
    recursiveFindPath(paginas, pageName);

    const isDashboardRoot =
      pageName === "/dashboard" || pageName === "/dashboard/";
    if (isDashboardRoot && paginas?.length > 0) {
      const firstPage = findFirstFilho(paginas);
      if (firstPage) {
        setTitlePage(firstPage.title);
        setSelectedItems([firstPage.id]);
      }
    }
  }, [paginas]);

  function recursiveFindPath(
    paginas: Dash[],
    pageName: string,
    paternal?: { id: string; title: string },
    sourceNodeId: string = "",
  ): Array<string> | undefined {
    let sourceNodeIdSave = sourceNodeId;

    const dashboardMatch = pageName.match(/^\/dashboard\/(.+)$/);
    const dashboardId = dashboardMatch ? dashboardMatch[1] : null;

    paginas?.map((pagina: Dash) => {
      if (pagina?.type === "FILHO") {
        const isPathMatch = pagina?.path === pageName;
        const isDashboardMatch = dashboardId && pagina?.id === dashboardId;

        if (isPathMatch || isDashboardMatch) {
          setTitlePage(pagina?.title);
          setSelectedItems([pagina?.id, paternal?.id ?? ""]);
        }
        return;
      }

      if (pagina?.type === "PAI") {
        const isDashboardMatch = dashboardId && pagina?.id === dashboardId;
        if (isDashboardMatch) {
          setTitlePage(pagina?.title);
          setSelectedItems([pagina?.id]);
        }

        setExpandedItems((prev) => {
          if (prev?.includes(pagina?.id)) {
            return prev;
          }
          return [...(prev || []), pagina?.id];
        });
        if (!sourceNodeIdSave) {
          sourceNodeIdSave = pagina?.id;
        }
        if (pagina.subPages)
          recursiveFindPath(
            pagina.subPages,
            pageName,
            { id: pagina.id, title: pagina.title },
            sourceNodeIdSave,
          );
      }
    });
    return;
  }
  const styles = {
    simpleTreeView: {
      width: open ? 290 : 56,
      paddingX: 2,
      paddingY: "5px",
    },
    title: {
      flexGrow: 1,
      fontWeight: 700,
      fontSize: "12px",
      marginX: 1,
      marginY: 1,
      color: "#919EAB",
      textTransform: "uppercase",
    },
  };

  function recursiveTreeItem(
    paginas: Dash[],
    paternal?: { id: string; title: string },
    nivel: number = 0,
  ): React.ReactNode {
    let countNivel = nivel;
    return paginas?.map((pagina: Dash) => {
      if (pagina.type === "FILHO") {
        countNivel++;

        return (
          <CustomTreeItem
            id={pagina.id}
            itemId={pagina.id}
            key={pagina.id}
            title={pagina.title}
            path={pagina.path}
            tipo={pagina.type}
            setSelectedItems={setSelectedItems}
            setExpandedItems={setExpandedItems}
            selectedItems={selectedItems}
            expandedItems={expandedItems}
            open={open}
            setOpen={setOpen}
            apiRef={apiRef}
            closeOnClickItem={closeOnClickItem}
            setTitlePage={setTitlePage}
            setLink={setLink}
            paternal={paternal}
            nivel={countNivel}
            usePath={pagina.usePath}
          />
        );
      }
      if (pagina.type === "PAI") {
        countNivel++;
        const childRoutes = recursiveTreeItem(
          pagina.subPages,
          {
            id: pagina.id,
            title: pagina.title,
          },
          countNivel,
        );

        return (
          <CustomTreeItem
            id={pagina.id}
            itemId={pagina.id}
            key={pagina.id}
            title={pagina.title}
            // path={pagina.path}
            tipo={pagina.type}
            setSelectedItems={setSelectedItems}
            setExpandedItems={setExpandedItems}
            selectedItems={selectedItems}
            expandedItems={expandedItems}
            open={open}
            setOpen={setOpen}
            apiRef={apiRef}
            closeOnClickItem={closeOnClickItem}
            setTitlePage={setTitlePage}
            setLink={setLink}
            nivel={countNivel}
            usePath={pagina.usePath}
          >
            {childRoutes}
          </CustomTreeItem>
        );
      }
    });
  }

  return (
    <SimpleTreeView
      selectedItems={selectedItems ?? []}
      // defaultExpandedItems={defaultExpandedItems}
      // defaultSelectedItems={defaultSelectedItems}
      expandedItems={expandedItems ?? []}
      multiSelect
      sx={styles.simpleTreeView}
      apiRef={apiRef}
    >
      {open && (
        <>
          {pageConfig && (
            <>
              <Button
                startIcon={<ArrowBack />}
                sx={{ color: theme.palette.primary.main }}
                variant="text"
                // onClick={() => navigate("/")}
                onClick={() => (window.location.href = "/")}
              >
                Voltar
              </Button>
              <Divider />
            </>
          )}
          <Typography
            key={"DASD"}
            variant="h6"
            component="div"
            sx={styles.title}
          >
            {pageConfig ? "Configurações" : "Navegação"}
          </Typography>
        </>
      )}
      {recursiveTreeItem(paginas)}
    </SimpleTreeView>
  );
}
export default CustomTreeView;
